import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
export default function CircularLoader({ size = "3rem", minHeight = "0px" }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: minHeight,
      }}
    >
      <CircularProgress size={size} sx={{ color: "#3cab5c" }} />
    </Box>
  );
}
